import { Box, Card, CardBody, CardHeader, Heading, Stack, StackDivider, Text } from '@chakra-ui/react'
import React from 'react'

const PrecannedQueries = ({ precannedQueries }) => {
    return (
        <Box width="85%">
            <Card mt="4">
                <CardHeader>
                    <Heading size='md'>Some queries you can try: </Heading>
                </CardHeader>
                <CardBody>
                    <Stack divider={<StackDivider />} spacing='4'>
                        {
                            precannedQueries.map((item, index) =>
                                <Box key={index}>
                                    <Text fontSize='sm'>
                                        {item.description}
                                    </Text>
                                </Box>)
                        }
                    </Stack>
                </CardBody>
            </Card>
        </Box>
    )
}

export default PrecannedQueries